import { NavLink } from "react-router-dom";
import { usePrefs } from "@/context/PrefsContext";

export const LANGUAGE_SUBNAV = [
  { to: "/modules", id: "japanese", label_id: "MANABI JAPANESE", label_jp: "MANABI 日本語", end: true },
  { to: "/modules/english", id: "english", label_id: "MANABI ENGLISH", label_jp: "MANABI 英語", soon: true },
];
export const SKILLS_SUBNAV = [
  { to: "/skills/caregiver", id: "caregiver", label_id: "Caregiver SSW1", label_jp: "介護1号" },
  { to: "/skills/caregiver-l2", id: "caregiver-l2", label_id: "Caregiver SSW2", label_jp: "介護2号" },
  { to: "/skills/agriculture", id: "agriculture", label_id: "Pertanian SSW2", label_jp: "農業2号" },
  { to: "/skills/logistics", id: "logistics", label_id: "Logistic & Warehouse", label_jp: "物流・倉庫", soon: true },
];

export const ASSESSMENT_SUBNAV = [
  { to: "/assessment", id: "language", label_id: "Bahasa", label_jp: "言語", end: true },
  { to: "/assessment/skills", id: "skills", label_id: "Keterampilan", label_jp: "技能" },
];

export function SubNav({ items, testid = "subnav" }) {
  const { lang } = usePrefs();
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {items.map((it) => (
        <NavLink key={it.id} to={it.to} end={it.end} data-testid={`${testid}-${it.id}`} className={({ isActive }) => `inline-flex shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors ${isActive ? "border-foreground bg-foreground text-background" : "border-border text-muted-foreground hover:bg-accent hover:text-foreground"}`}>
          {lang === "jp" ? it.label_jp : it.label_id}
          {it.soon && <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-amber-800">Coming soon</span>}
        </NavLink>
      ))}
    </div>
  );
}
